var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTatics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.64453 0.755859L12 3.09961V4.78516H10.46V4.20117H9.66309V12.2188H2.33594V4.20117H1.54004V4.78516H0V3.09961L2.33691 0.763672L4.08594 0.75293C4.33912 1.38979 4.84761 1.97455 5.41211 2.35938C5.51567 2.42995 5.88232 2.65883 5.9873 2.66309C6.16222 2.67045 6.71052 2.28144 6.8623 2.15625C7.29668 1.79839 7.70769 1.27809 7.91406 0.75293L9.64453 0.755859ZM5.23047 7.3877H6.26562L5.3916 9.84082L6.12012 10.1182L7.16797 7.26758V6.59082H5.23047V7.3877ZM1.54004 6.37793H0V5.58203H1.54004V6.37793ZM12 5.58203V6.37793H10.46V5.58203H12ZM8.49512 3.88281C8.23353 3.8702 8.01241 4.01647 7.84473 4.20117C7.79791 4.25305 7.62554 4.52965 7.58008 4.51953C7.36235 4.21067 7.11553 3.86734 6.69043 3.88281V4.66602C6.69096 4.68753 6.90979 4.96191 6.94238 4.99805C7.34422 5.44097 7.86219 5.42495 8.25586 4.9834C8.2878 4.94769 8.49456 4.68645 8.49512 4.66602V3.88281ZM3.82324 4.99805H4.61914V4.20117H3.82324V4.99805ZM7.03516 0.75C6.77341 1.16494 6.42637 1.54753 5.99121 1.78125C5.56965 1.52732 5.22441 1.16627 4.96484 0.75H7.03516Z",
    fill: "url(#paint0_linear_499_33357)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_499_33357",
    x1: 0.229008,
    y1: 12.2187,
    x2: 14.7929,
    y2: 11.9214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108167,
    stopColor: "#231E1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89767A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTatics);
export default __webpack_public_path__ + "static/media/tatics.f940160115c8bbf5e6ff1faee8df91c5.svg";
export { ForwardRef as ReactComponent };